import React, { useState, useEffect } from 'react';
import { X, Check } from 'lucide-react';

export const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  // Default Preferences
  const [prefs, setPrefs] = useState({
    necessary: true, // Always true/locked
    performance: true,
    marketing: true
  });

  useEffect(() => {
    // Check if user already saved cookies
    const savedCookie = localStorage.getItem('vntg-cookie-consent');
    if (!savedCookie) {
      // Small delay for smooth entrance
      setTimeout(() => setIsVisible(true), 1000);
    }
  }, []);

  const handleSave = (newPrefs) => {
    localStorage.setItem('vntg-cookie-consent', JSON.stringify(newPrefs));
    setIsVisible(false);
    setIsModalOpen(false);
  };

  const acceptAll = () => handleSave({ necessary: true, performance: true, marketing: true });
  const rejectAll = () => handleSave({ necessary: true, performance: false, marketing: false });
  const saveCurrent = () => handleSave(prefs);

  const togglePref = (key) => {
    if (key === 'necessary') return; // Locked
    setPrefs(prev => ({ ...prev, [key]: !prev[key] }));
  };

  if (!isVisible && !isModalOpen) return null;

  return (
    <>
      {/* --- 1. BOTTOM BANNER --- */}
      {isVisible && !isModalOpen && (
        <div className="cookie-banner-container fade-in">
          <div className="cookie-banner">
            <div className="cb-text">
              <h3>Cookie Policy Notice</h3>
              <p>
                We use cookies to enhance your site experience. You are in control - 
                customize your settings in our <span className="link">Privacy Policy</span>. 
                Feel free to explore before making a choice <span className="link underline" onClick={() => setIsModalOpen(true)}>Manage preferences</span>
              </p>
            </div>
            <div className="cb-actions">
              <button className="btn cb-btn-white" onClick={acceptAll}>Accept all</button>
              <button className="btn cb-btn-outline" onClick={rejectAll}>Reject all</button>
            </div>
          </div>
        </div>
      )}

      {/* --- 2. PREFERENCES MODAL --- */}
      {isModalOpen && (
        <div className="cookie-modal-overlay">
          <div className="cookie-modal fade-in">
            
            {/* Header */}
            <div className="cm-header">
              <h2>Cookie preferences</h2>
              <X className="close-icon" onClick={() => setIsModalOpen(false)} />
            </div>

            {/* Body */}
            <div className="cm-body custom-scrollbar">
              <p className="cm-desc">
                <strong>Cookie usage 📢</strong><br/>
                We use cookies to enhance your browsing experience on our website. These cookies help us analyze 
                site traffic, personalize content, and provide you with a better user experience. By continuing to use 
                our site, you consent to the use of cookies in accordance with our Cookie Policy.
              </p>

              {/* Toggles */}
              <div className="cm-toggles">
                
                {/* Strictly Necessary (Locked) */}
                <div className="cm-toggle-row">
                  <div className="cm-label">
                    <span className="cm-title">Strictly necessary cookies</span>
                  </div>
                  <div className="toggle-switch locked">
                    <Check size={12} color="black" />
                  </div>
                </div>

                {/* Performance */}
                <div className="cm-toggle-row" onClick={() => togglePref('performance')}>
                  <div className="cm-label">
                    <span className="cm-title">Performance and Analytics cookies</span>
                  </div>
                  <div className={`toggle-switch ${prefs.performance ? 'active' : ''}`}>
                    <div className="toggle-knob">
                      {prefs.performance ? <Check size={10} color="black" /> : <X size={10} color="black" />}
                    </div>
                  </div>
                </div>

                {/* Marketing */}
                <div className="cm-toggle-row" onClick={() => togglePref('marketing')}>
                  <div className="cm-label">
                    <span className="cm-title">Marketing and Targeting cookies</span>
                  </div>
                  <div className={`toggle-switch ${prefs.marketing ? 'active' : ''}`}>
                    <div className="toggle-knob">
                      {prefs.marketing ? <Check size={10} color="black" /> : <X size={10} color="black" />}
                    </div>
                  </div>
                </div>

              </div>
            </div>

            {/* Footer */}
            <div className="cm-footer">
              <div className="cm-footer-left">
                <button className="btn cb-btn-white small" onClick={acceptAll}>Accept all</button>
                <button className="btn cb-btn-outline small" onClick={rejectAll}>Reject all</button>
              </div>
              <button className="btn cb-btn-outline small" onClick={saveCurrent}>Save settings</button>
            </div>

          </div>
        </div>
      )}
    </>
  );
};